"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "GxNext", {
  enumerable: true,
  get: function () {
    return _GxNext.default;
  }
});
_Object$defineProperty(exports, "GxUi", {
  enumerable: true,
  get: function () {
    return _GxUi.default;
  }
});
var _GxNext = _interopRequireDefault(require("./GxNext"));
var _GxUi = _interopRequireDefault(require("./GxUi"));